
  import { Component, Vue } from "vue-property-decorator";

  @Component
  export default class NewVersionBanner extends Vue {
    refresh(): void {
      window.location.reload();
    }
  }
